import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=c0db4546&scoped=true"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db4546",
  null
  
)

export default component.exports